'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsCarousel = function () {
  function ProductsCarousel(el) {
    var _perPage;

    (0, _classCallCheck3.default)(this, ProductsCarousel);

    var _this = this;
    var context = { context: el };

    this.els = {
      el: el,
      slides: (0, _functional.getElement)('.art-Products_Items', context),
      dots: (0, _functional.getElement)('.art-Products_Dots', context),
      controls: (0, _functional.getElement)('.art-Products_Controls', context)
    };

    this.amountOfDotsWanted = null;
    this.dotEls = null;

    this.productsPerSlide = parseInt(this.els.el.dataset.productsPerSlide, 10);

    this.carousel = new _siema2.default({
      selector: this.els.slides,
      duration: 500,
      perPage: (_perPage = {}, (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.sm, 2), (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.md, this.productsPerSlide), _perPage),
      onInit: function onInit() {
        _this.initialiseDots(this);
      },
      onChange: function onChange() {
        var carousel = this;

        _this.dotEls.forEach(function (dotEl, index) {
          dotEl.setAttribute('aria-current', String(index === carousel.currentSlide));
        });
      }
    });
  }

  (0, _createClass3.default)(ProductsCarousel, [{
    key: 'initialiseDots',
    value: function initialiseDots(carousel) {
      var _this2 = this;

      this.amountOfDotsWanted = carousel.innerElements.length - (carousel.perPage - 1);
      this.dotEls = (0, _functional.range)(this.amountOfDotsWanted).map(function (_, index) {
        return (0, _functional.createElement)('div', {
          class: 'art-Products_Dot',
          'aria-current': String(index === carousel.currentSlide)
        });
      }).map(function (el) {
        return _this2.els.dots.appendChild(el);
      });

      this.dotEls.forEach(function (el, index) {
        return el.addEventListener('click', function () {
          return carousel.goTo(index);
        });
      });
    }
  }]);
  return ProductsCarousel;
}();

exports.default = ProductsCarousel;